import { AssemblyAiToken } from "@/modules/audio-recording/audio-recording.types";
import type {
  TranscriptSpeakerIdentificationContext,
  TranscriptSpeakerIdentificationReason,
  TranscriptSpeakerAudioSource,
  TranscriptSpeakerParticipantMetadata,
  TranscriptSpeakerVariant,
} from "@/modules/audio-recording/transcript-types";

/**
 * Maps to their V3 streaming types here:
 * - https://www.assemblyai.com/docs/api-reference/streaming-api/streaming-api
 */
export enum AssemblyAiTranscriberPayloadType {
  Begin = "Begin",
  Turn = "Turn",
  Termination = "Termination",
  Unknown = "Unknown",
}

export type WebMediaTranscriberInitialConnectRetryConfig = {
  retries?: number;
  factor?: number;
  minTimeoutMs?: number;
  maxTimeoutMs?: number;
};

export type WebMediaTranscriberOptions = {
  tokenProvider: () => Promise<AssemblyAiToken>;
  stream: MediaStream;
  customVocabulary?: string[];
  initialConnectRetryConfig?: WebMediaTranscriberInitialConnectRetryConfig;
  /** Reject stop() unless local audio, the final turn, and server termination are proven. */
  requireCompleteFinalization?: boolean;
};

export type DesktopRecorderTranscriptTurnWord = {
  text: string;
  startMs: number;
  endMs: number;
  confidence: number;
};

export type DesktopRecorderTranscriptTurn = {
  turnOrder: number;
  transcript: string;
  timestampMs: number;
  isFormatted: boolean;
  isEndOfTurn: boolean;
  endOfTurnConfidence: number;
  participantId?: number | string | null;
  speakerParticipant?: TranscriptSpeakerParticipantMetadata | null;
  speakerId?: string | null;
  speakerVariant?: TranscriptSpeakerVariant | null;
  speakerIdentificationContext?: TranscriptSpeakerIdentificationContext | null;
  speakerIdentificationReason?: TranscriptSpeakerIdentificationReason | null;
  speakerAudioSource?: TranscriptSpeakerAudioSource | null;
  words: DesktopRecorderTranscriptTurnWord[];
  raw?: unknown;
};

export type DesktopRecorderTranscriptPartialTurn = DesktopRecorderTranscriptTurn & {
  isEndOfTurn: false;
};

export type DesktopRecorderTranscriptFinalTurn = DesktopRecorderTranscriptTurn & {
  isEndOfTurn: true;
};
